export const AppGetAllAdminSubClasses = "/admin/sub-class/";

export const AppGetAdminSubClassById = "/admin/sub-class/:id";

export const AppSaveAdminSubClass = "/admin/sub-class/create";

export const AppUpdateAdminSubClass = "/admin/sub-class/update/:id";

export const AppDeleteAdminSubClass = "/admin/sub-class/delete/:id";

export const AppSaveLoyaltyConfig = "/admin/loyalty-config/create";

export const AppGetLoyaltyConfig = "/admin/loyalty-config/";